module.exports = __webpack_public_path__ + "img/55.4f08c3a8.png";